"use strict";

exports.__esModule = true;
exports.default = toPath;
var _underscore = _interopRequireDefault(require("./underscore.js"));
require("./toPath.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Internal wrapper for `_.toPath` to enable minification.
// Similar to `cb` for `_.iteratee`.
function toPath(path) {
  return _underscore.default.toPath(path);
}